export const getSilverStock = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL, {
            method: 'POST',
            body: JSON.stringify({
                apiKey: "DHRUVDARSHAN",
                action: "getSilverStock",
                origin: window.location.origin
            })
        });

        const result = await response.json();

        if (result.success) {
            return result.data;
        } else {
            throw new Error(result.error || 'Failed to get silver stock');
        }
    } catch (error) {
        console.error('Error getting silver stock:', error);
        throw error;
    }
};

export const getSilverTransactions = async (filters = {}) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL, {
            method: 'POST',
            body: JSON.stringify({
                apiKey: "DHRUVDARSHAN",
                action: "getSilverTransactions",
                origin: window.location.origin,
                ...filters
            })
        });

        const result = await response.json();

        if (result.success) {
            return result.data;
        } else {
            throw new Error(result.error || 'Failed to get silver transactions');
        }
    } catch (error) {
        console.error('Error getting silver transactions:', error);
        throw error;
    }
};

export const updateSilverStock = async (silverType, netWeight, operation, description) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL, {
            method: 'POST',
            body: JSON.stringify({
                apiKey: "DHRUVDARSHAN",
                action: "updateSilverStock",
                origin: window.location.origin,
                silverType: silverType,
                netWeight: parseFloat(netWeight),
                operation: operation,
                description: description
            })
        });

        const result = await response.json();

        if (result.success) {
            return result.data;
        } else {
            throw new Error(result.error || 'Failed to update silver stock');
        }
    } catch (error) {
        console.error('Error updating silver stock:', error);
        throw error;
    }
};

export const bulkUpdateSilverStock = async (updates) => {
    try {
        // Validate input
        if (!Array.isArray(updates) || updates.length === 0) {
            throw new Error('Updates array cannot be empty');
        }

        // Validate each update
        const validatedUpdates = updates.map((update, index) => {
            const { silverType, netWeight, operation, description = '' } = update;

            // Validate required fields
            if (!silverType) {
                throw new Error(`Update ${index + 1}: Silver type is required`);
            }

            if (!['999silver', '925silver', 'mixsilver', 'silver', 'oldsilver', 'gold'].includes(silverType)) {
                throw new Error(`Update ${index + 1}: Invalid silver type "${silverType}". Valid types: 999silver, 925silver, mixsilver, silver, oldsilver, 'gold`);
            }

            if (!netWeight || isNaN(parseFloat(netWeight)) || parseFloat(netWeight) <= 0) {
                throw new Error(`Update ${index + 1}: Valid net weight is required`);
            }

            if (!['add', 'subtract'].includes(operation)) {
                throw new Error(`Update ${index + 1}: Operation must be "add" or "subtract"`);
            }

            return {
                silverType,
                netWeight: parseFloat(netWeight),
                operation,
                description: description.toString().trim()
            };
        });

        // Make API call
        const response = await fetch(process.env.REACT_APP_API_URL, {
            method: 'POST',
            body: JSON.stringify({
                apiKey: "DHRUVDARSHAN",
                action: "bulkUpdateSilverStock",
                origin: window.location.origin,
                updates: validatedUpdates
            })
        });

        const result = await response.json();

        if (result.success) {
            return {
                success: true,
                data: result.data,
                message: result.data?.message || 'Bulk update completed successfully'
            };
        } else {
            throw new Error(result.error || 'Failed to perform bulk update');
        }
    } catch (error) {
        console.error('Error in bulk silver update:', error);
        return {
            success: false,
            error: error.message,
            message: `Bulk update failed: ${error.message}`
        };
    }
};
export const initializeSilverStock = async () => {
  try {
    const response = await fetch(process.env.REACT_APP_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        apiKey: "DHRUVDARSHAN",
        action: "initializeSilverStock",
        origin: window.location.origin
      })
    });

    const result = await response.json();
    
    if (result.success) {
      return {
        success: true,
        data: result.data,
        message: result.data?.message || 'Silver stock initialized successfully'
      };
    } else {
      throw new Error(result.error || 'Failed to initialize silver stock');
    }
  } catch (error) {
    console.error('Error initializing silver stock:', error);
    return {
      success: false,
      error: error.message,
      message: `Initialization failed: ${error.message}`
    };
  }
};